module.exports = __webpack_public_path__ + "img/help-desk-hand.b9705372.svg";